
import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/shared/Layout";
import Dashboard from "./pages/Dashboard";
import Beneficiary from "./pages/Beneficiaries/Beneficiary";
import Transaction from "./pages/Transactions/Transaction";
import Membership from "./pages/Memberships/Membership";
import Report from "./pages/Report";
import Configuration from "./pages/Configuration";
import ComplianceAlert from "./pages/ComplianceAlert";
import RolesAndPermission from "./pages/RolesAndPermission";
import GeneralSettings from "./pages/GeneralSettings";
import EditBeneficiary from './pages/Beneficiaries/EditBeneficiary';
import TransactionShow from './pages/Transactions/TrasnactionShow';
import MembershipShow from './pages/Memberships/MembershipShow';
import Login from './pages/Login';
import StaffLogin from './pages/staffLogin';
import CurrencyDashboard from "./pages/CurrencyDashboard";
import SendMoney from "./pages/SendMoney";
import PaymentConfirmation from "./pages/PaymentConfirmation";
import CurrencyConverterScreen from "./pages/CurrencyConverterScreen";
import PaymentSuccess from './pages/PaymentSuccess';
// import AddBalance from "./pages/AddBalance";
import RenderUrl from "./pages/renderUrl";
import BeneficiaryTypes from "./pages/BeneficiaryTypes";
import SelfAccount from "./pages/SelfAccount";
import BeneficiaryOtpScreen from "./pages/BeneficiaryOtpScreen";
import BusinessAccount from "./pages/BusinessAccount";
import Register from "./pages/Register";
import VerifyPhone from "./pages/VerifyPhone";
import VerifyEmail from "./pages/VerifyEmail";
import SumSubRegister from "./pages/SumSubRegister";
import SumsubReKyc from "./pages/SumsubReKyc";
import ApplicationPreview from "./pages/ApplicationPreview";
import BusinessDetails from "./pages/BusinessDetails";
import AboutBusiness from "./pages/AboutBusiness";
import BusinessAddress from "./pages/BusinessAddress";
import SelectOfficer from "./pages/SelectOfficer";
import NotFound from './pages/not-found';
import Conversions from './pages/Conversions';
import ForgotPin from "./pages/forgotPin";
import CCTransCreditDetails from "./pages/Transactions/CCTransCreditDetails";
import CCTransDebitDetails from "./pages/Transactions/CCTransDebitDetails";
import CBTransCreditDetails from "./pages/Transactions/CBTransCreditDetails";
import TransDebitDetails from "./pages/Transactions/TransDebitDetails";
// import Homepage from "./pages/Homepage";
import FrontLayout from './components/shared/FrontLayout';
import BusinessPage from './pages/BusinessPage';
import FintechPage from './pages/FintechPage';
import DebitTransactions from "./pages/Transactions/DebitTransactions";
import CreditTransactions from "./pages/Transactions/CreditTransactions";
import BulkUpload from "./pages/BulkUpload";
import FilteredTransaction from "./pages/Transactions/FilteredTransactions";
import ListBeneficiaries from "./pages/ListBeneficiaries";
import SendMoneyByBeneficiary from "./pages/SendMoneyByBeneficiary";
import SelectCurrencyForBeneficiary from "./pages/SelectCurrencyForBeneficiary";
import Pay from "./pages/Pay";
import CurrencyConverterFormScreen from "./pages/CurrencyConverterFormScreen";
import ShowAccounts from "./pages/ShowAccounts";
import UserDetails from "./pages/userDetails";
import ListUsers from "./pages/ListUsers/ListUsers";
import Stats from "./pages/Stats";
import SetFees from "./pages/SetFees";
import CreateTicket from "./pages/CreateTicket";
import ListTickets from "./pages/ListTickets";
import ViewTicketDetails from "./pages/ViewTicketDetails";
import BeneficiaryDetail from "./pages/Beneficiaries/BeneficiaryDetail";
import NotificationDrawer from "./pages/Notifications/Notifications";
import AllTickets from "./pages/AllTickets";
import AccountTypeSelector from "./pages/AccountType";
import BulkuploadCsvErrorPreview from "./pages/BulkuploadCsvErrorPreview";
import SendMoneyCurrency from "./pages/SendMoneyCurrency";
import TransactionDetailView from "./pages/TransactionDetailView";
import FasterPayment from "./pages/Faster Payments/FasterPayment";
import FasterPayemtPreviewScreen from "./pages/Faster Payments/FasterPayemtPreviewScreen";

import Voltsuccess from "./pages/Voltsuccess";
import Voltfailed from "./pages/Voltfailed";
import Voltcancelled from "./pages/Voltcancelled";
import AccountSuccess from "./pages/AccountSuccess";
import OrgAccountReview from "./pages/OrgAccountReview";
import SendMoneyTab from "./pages/SendMoneyTab";
import SendMoneyPaymentConfirmation from "./pages/SendMoneyPaymentConfirmation";
import Verify2FA from "./pages/Verify2FA";
import Checkyouremail from "./pages/Checkyouremail";
import PaymentMethodScreen from "./pages/PaymentMethodScreen";
import ManualTransferDetails from "./pages/ManualTransferScreen";
import VoltPaymentGatewayIframe from "./pages/VoltPaymentGatewayIframe";
import BulkUploadAuthorization from "./pages/BulkUploadAuthorization";
import YapilyStatus from "./pages/YapilyStatus";
// import Sendmoneyflow from "./pages/Sendmoneyflow";
import Recepient from "./pages/Recepient";
// import Createbulkmembership from "./pages/Createbulkmembership";
import Createmembership from "./pages/Createmembership";
import Choosepayment from "./pages/Choosepayment";
import ConversionReview from "./pages/ConversionReview";
// import BulkUploadReplica from "./pages/BulkUploadReplica";
// import BulkUploadReplicaTwo from "./pages/BulkUploadReplicaTwo";
import YapilyStatusReplica from "./pages/YapilyStatusReplica";
import Conversionsuccess from './pages/Conversionsuccess';
import TransactionListDetails from "./pages/Transactions/TransactionListDetails";
import SendMoneyBeneficiaryDetail from "./pages/Sendmoneybeneficiarydetail";
import Banks from './pages/Banks';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import setupAxiosInterceptor from "./lib/axiosInstance";
import Paymentqr from "./pages/Paymentqr";

setupAxiosInterceptor();
export default function App() {


  // const [showBanner, setShowBanner] = useState(false);
  // const [storeUrl, setStoreUrl] = useState("");



  useEffect(() => {
    //    console.log("User Agent:", navigator.userAgent);
    // alert(navigator.userAgent);

    console.log("window");
    
    // OneSignal.init({
    //   appId: "69c7aa9b-1409-4db5-b02f-f8941d1c876f"
    // });
  }, []);




  return (



    <>
      <ToastContainer position="top-right" />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />}></Route>
          <Route path="notifications" element={<NotificationDrawer />}></Route>
          <Route path="beneficiaries" element={<Beneficiary />}></Route>
          <Route path="Pay" element={<Pay />}></Route>
          <Route path="beneficiaries/edit" element={<EditBeneficiary />}></Route>
          <Route path="beneficiary-detail" element={<BeneficiaryDetail />}></Route>
          <Route path="transactions" element={<Transaction />}></Route>
          <Route path="conversions" element={<Conversions />}></Route>
          <Route path="transactions/show" element={<TransactionShow />}></Route>
          <Route path="memberships" element={<Membership />}></Route>
          <Route path="userDetails" element={<UserDetails />}></Route>
          <Route path="SetFees" element={<SetFees />}></Route>
          <Route path="ListUsers" element={<ListUsers />}></Route>
          <Route path="memberships/show" element={<MembershipShow />}></Route>
          <Route path="reports" element={<Report />}></Route>
          <Route path="configurations" element={<Configuration />}></Route>
          <Route path="compliance-alerts" element={<ComplianceAlert />}></Route>
          <Route path="roles-and-permissions" element={<RolesAndPermission />}></Route>
          <Route path="general-settings" element={<GeneralSettings />}></Route>
          <Route path="currencyDashboard" element={<CurrencyDashboard />}></Route>
          <Route path="sendMoney" element={<SendMoney />}></Route>
          <Route path="SelectCurrencyForBeneficiary" element={<SelectCurrencyForBeneficiary />}></Route>
          <Route path="CurrencyConverterFormScreen" element={<CurrencyConverterFormScreen />}></Route>
          <Route path="PaymentConfirmation" element={<PaymentConfirmation />}></Route>
          <Route path="CurrencyConverterScreen" element={<CurrencyConverterScreen />}></Route>
          <Route path="PaymentSuccess" element={<PaymentSuccess />}></Route>
          {/* <Route path="AddBalance" element={<AddBalance />}></Route> */}
          <Route path="ShowAccounts" element={<ShowAccounts />}></Route>
          <Route path="RenderUrl" element={<RenderUrl />}></Route>
          <Route path="BeneficiaryTypes" element={<BeneficiaryTypes />}></Route>
          <Route path="SelfAccount" element={<SelfAccount />}></Route>
          <Route path="BeneficiaryOtpScreen" element={<BeneficiaryOtpScreen />}></Route>
          <Route path="BusinessAccount" element={<BusinessAccount />}></Route>
          <Route path="CCTransCreditDetails" element={<CCTransCreditDetails />}></Route>
          <Route path="CCTransDebitDetails" element={<CCTransDebitDetails />}></Route>
          <Route path="CBTransCreditDetails" element={<CBTransCreditDetails />}></Route>
          <Route path="TransDebitDetails" element={<TransDebitDetails />}></Route>
          <Route path="DebitTransactions" element={<DebitTransactions />}></Route>
          <Route path="CreditTransactions" element={<CreditTransactions />}></Route>
          <Route path="bulkupload" element={<BulkUpload />}></Route>
          <Route path="FilteredTransaction" element={<FilteredTransaction />}></Route>
          <Route path="ListBeneficiaries" element={<ListBeneficiaries />}></Route>
          <Route path="createticket" element={<CreateTicket />}></Route>
          <Route path="contactsupport" element={<ListTickets />}></Route>
          <Route path="SendMoneyTab" element={<SendMoneyTab />}></Route>
          <Route path="SendMoneyCurrency" element={<SendMoneyCurrency />}></Route>

          <Route path="ticketdetails/:id" element={<ViewTicketDetails />}></Route>
          <Route path="alltickets" element={<AllTickets />}></Route>
          <Route path="SendMoneyByBeneficiary" element={<SendMoneyByBeneficiary />}></Route>
          <Route path="SendMoneyPaymentConfirmation" element={<SendMoneyPaymentConfirmation />}></Route>
          <Route path="payment-method" element={<PaymentMethodScreen />}></Route>
          <Route path="/Banks" element={<Banks />}></Route>
          <Route path="manual-transfer" element={<ManualTransferDetails />}></Route>
          <Route path="VoltPaymentGatewayIframe" element={<VoltPaymentGatewayIframe />}></Route>
          <Route path="bulkupload-autorization" element={<BulkUploadAuthorization />}></Route>
          {/* <Route path = "sendmoneyflow" element = {<Sendmoneyflow />}></Route> */}
          <Route path="Recepient" element={<Recepient />}></Route>
          {/* <Route path="createbulkmemebership" element={<Createbulkmembership />}></Route> */}
          <Route path="createmembership" element={<Createmembership />}></Route>
          <Route path="/Choosepayment" element={<Choosepayment />}></Route>
          {/* <Route path="/BulkUploadReplica1" element={<BulkUploadReplica />}></Route>
        <Route path="/BulkUploadReplica2" element={<BulkUploadReplicaTwo />}></Route> */}
          <Route path="/YapilyStatusReplica" element={<YapilyStatusReplica />}></Route>
          <Route path="/review" element={<ConversionReview />}></Route>
          <Route path="/transactionviewdetails" element={<TransactionDetailView />}></Route>
          <Route path="/FasterPayment" element={<FasterPayment />}></Route>
          <Route path="/FasterPayemtPreviewScreen" element={<FasterPayemtPreviewScreen />}></Route>
          <Route path='/Conversionsuccess' element={<Conversionsuccess />}></Route>
          <Route path="/TransactionListDetails" element={<TransactionListDetails />}></Route>





        </Route>
        <Route path="/" element={<FrontLayout />}>
          {/* <Route path="Homepage" element={<Homepage />}></Route> */}
          <Route path="business" element={<BusinessPage />}></Route>
          <Route path="fintech" element={<FintechPage />}></Route>
        </Route>
        <Route path="stats" element={<Stats />}></Route>
        <Route path="yapilyStatus" element={<YapilyStatus />}></Route>
        <Route path="/payment-qr" element={<Paymentqr />}></Route>
        <Route path="voltsuccess" element={<Voltsuccess />}></Route>
        <Route path="voltfailed" element={<Voltfailed />}></Route>
        <Route path="voltcancelled" element={<Voltcancelled />}></Route>
        <Route path="login" element={<Login />}></Route>
        <Route path="stafflogin" element={<StaffLogin />}></Route>
        <Route path="/register/:type" element={<Register />}></Route>
        <Route path="account-type" element={<AccountTypeSelector />}></Route>
        <Route path="org-account-review" element={<OrgAccountReview />}></Route>
        <Route path="VerifyPhone" element={<VerifyPhone />}></Route>
        <Route path="VerifyEmail" element={<VerifyEmail />}></Route>
        <Route path="Welcome" element={<AccountSuccess />}></Route>
        <Route path="SumSubRegister" element={<SumSubRegister />}></Route>
        <Route path="SumsubReKyc" element={<SumsubReKyc />}></Route>
        <Route path="ApplicationPreview" element={<ApplicationPreview />}></Route>
        <Route path="BusinessDetails" element={<BusinessDetails />}></Route>
        <Route path="AboutBusiness" element={<AboutBusiness />}></Route>
        <Route path="BusinessAddress" element={<BusinessAddress />}></Route>
        <Route path="SelectOfficer" element={<SelectOfficer />}></Route>
        <Route path="bulk-upload-csv-error-preview" element={<BulkuploadCsvErrorPreview />}></Route>
        <Route path="*" element={<NotFound />}></Route>
        <Route path="ForgotPin" element={<ForgotPin />}></Route>
        <Route path="/verify-2fa" element={<Verify2FA />} />
        <Route path="Checkyouremail" element={<Checkyouremail />}></Route>
        <Route path="/Choosepayment" element={<Choosepayment />}></Route>
        <Route path='/SendMoneyBeneficairyDetail' element={<SendMoneyBeneficiaryDetail />}></Route>
      </Routes>
    </>
  )
}

